<template>
  <div></div>
</template>
  
<script>
export default {
  data() {
    return {
      lang: ''
    }
  },
  beforeMount() {
    this.lang = window.MY_CONFIG_EASYQ.lang;

    const url = window.location.href;
    const re = url.split('/');
    // console.log(re);
    if(re.length == 4) {
      window.location = re[0] + '//' + re[2] + '/' + re[3] + '/' + this.lang + '/';
    } else if(re.length == 5) {
      window.location = re[0] + '//' + re[2] + '/' + re[3] + '/' + this.lang + '/';
    }
  },
}
</script>